/**
 * Product description accordions — <details class="product-accordion">
 * Builds tabs from product.description h5 headings; appends theme blocks from Liquid.
 */
(function () {
  var ALLOWED_TAGS = [
    'P', 'UL', 'OL', 'LI', 'A', 'IMG', 'STRONG', 'B', 'EM', 'I', 'BR',
    'TABLE', 'TBODY', 'THEAD', 'TR', 'TD', 'TH', 'H5', 'H6', 'DIV', 'SPAN'
  ];

  function titleCase(str) {
    if (!str || !str.trim()) return str;
    return str
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function sanitizeNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var text = node.textContent;
      if (!text.trim()) return null;
      return document.createTextNode(text);
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return null;
    }

    var tag = node.tagName;

    if (!ALLOWED_TAGS.includes(tag)) {
      var fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(node.childNodes, function (child) {
        var sanitized = sanitizeNode(child);
        if (sanitized) fragment.appendChild(sanitized);
      });
      return fragment;
    }

    var clone = document.createElement(tag.toLowerCase());

    if (tag === 'A') {
      if (node.href) clone.href = node.href;
      if (node.target) clone.target = node.target;
      if (node.rel) clone.rel = node.rel;
    }

    if (tag === 'IMG') {
      if (node.src) clone.src = node.src;
      if (node.alt) clone.alt = node.alt;
      if (node.width) clone.width = node.width;
      if (node.height) clone.height = node.height;
    }

    Array.prototype.forEach.call(node.childNodes, function (child) {
      var sanitized = sanitizeNode(child);
      if (sanitized) clone.appendChild(sanitized);
    });

    return clone;
  }

  function sanitizeHtml(html) {
    var parser = document.createElement('div');
    parser.innerHTML = html;
    parser.querySelectorAll('meta, script, style').forEach(function (el) {
      el.remove();
    });

    var wrapper = document.createElement('div');
    Array.prototype.forEach.call(parser.childNodes, function (node) {
      var sanitized = sanitizeNode(node);
      if (sanitized) wrapper.appendChild(sanitized);
    });

    wrapper.querySelectorAll('p, ul, ol').forEach(function (el) {
      if (!el.textContent.trim() && !el.querySelector('img')) {
        el.remove();
      }
    });

    return wrapper.innerHTML.trim();
  }

  function getContentBetweenHeadings(parser, currentHeading, nextHeading) {
    var range = document.createRange();
    range.setStartAfter(currentHeading);

    if (nextHeading) {
      range.setEndBefore(nextHeading);
    } else if (parser.lastChild) {
      range.setEndAfter(parser.lastChild);
    } else {
      return document.createDocumentFragment();
    }

    return range.cloneContents();
  }

  function fragmentToHtml(fragment) {
    var wrapper = document.createElement('div');
    wrapper.appendChild(fragment);
    return sanitizeHtml(wrapper.innerHTML);
  }

  function getIntroHtml(parser, firstHeading) {
    if (!firstHeading) {
      return sanitizeHtml(parser.innerHTML);
    }

    var range = document.createRange();
    range.setStart(parser, 0);
    range.setEndBefore(firstHeading);
    var fragment = range.cloneContents();
    var html = fragmentToHtml(fragment);
    var textOnly = document.createElement('div');
    textOnly.innerHTML = html;
    if (!textOnly.textContent.trim() && !textOnly.querySelector('img')) {
      return '';
    }
    return html;
  }

  function buildDescriptionSections(sourceHtml, descriptionLabel) {
    var parser = document.createElement('div');
    parser.innerHTML = sourceHtml;
    parser.querySelectorAll('meta, script, style').forEach(function (el) {
      el.remove();
    });

    var headings = Array.prototype.slice.call(parser.querySelectorAll('h5'));
    var sections = [];

    if (!headings.length) {
      var full = sanitizeHtml(parser.innerHTML);
      if (full) {
        sections.push({ title: descriptionLabel, content: full });
      }
      return sections;
    }

    var intro = getIntroHtml(parser, headings[0]);
    if (intro) {
      sections.push({ title: descriptionLabel, content: intro });
    }

    headings.forEach(function (heading, index) {
      var nextHeading = headings[index + 1];
      var title = heading.textContent.trim();
      if (!title) return;

      var fragment = getContentBetweenHeadings(parser, heading, nextHeading);
      var content = fragmentToHtml(fragment);
      if (!content) return;

      sections.push({ title: titleCase(title), content: content });
    });

    return sections;
  }

  var isAccordionTransitioning = false;
  var anchorLockRaf = null;
  var anchorElement = null;
  var anchorViewportTop = null;
  var anchorScrollRoot = null;
  var SCROLL_DURATION_MS = 600;
  var SCROLL_INSTANT_LAYOUT_SHIFT_THRESHOLD = 400;
  var scrollAnimRaf = null;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function cancelScrollAnimation() {
    if (scrollAnimRaf) {
      cancelAnimationFrame(scrollAnimRaf);
      scrollAnimRaf = null;
    }
  }

  function isQuickViewContext(element) {
    return Boolean(element && element.closest('.modal--quick-shop'));
  }

  function getHeaderHeight() {
    var siteHeader = document.getElementById('SiteHeader');
    if (siteHeader) {
      return siteHeader.getBoundingClientRect().height;
    }

    var cssHeight = parseInt(
      window.getComputedStyle(document.documentElement).getPropertyValue('--headerAndAnnoucementbarheight'),
      10
    );

    return isNaN(cssHeight) ? 80 : cssHeight;
  }

  function getSummaryScrollTop(summary) {
    return Math.max(0, summary.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight());
  }

  function snapSummaryBelowHeader(summary) {
    if (!summary || isQuickViewContext(summary)) return;

    var delta = summary.getBoundingClientRect().top - getHeaderHeight();

    if (Math.abs(delta) >= 4) {
      window.scrollTo(0, Math.max(0, window.pageYOffset + delta));
    }
  }

  function instantScrollSummaryIntoView(summary) {
    if (!summary || isQuickViewContext(summary)) return;

    cancelScrollAnimation();
    window.scrollTo(0, getSummaryScrollTop(summary));
    snapSummaryBelowHeader(summary);
  }

  function smoothScrollSummaryIntoView(summary) {
    if (!summary || isQuickViewContext(summary)) return;

    cancelScrollAnimation();

    var currentTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var initialTarget = getSummaryScrollTop(summary);

    if (Math.abs(initialTarget - currentTop) < 2) return;

    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;

      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / SCROLL_DURATION_MS, 1);
      var targetTop = getSummaryScrollTop(summary);
      currentTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var diff = targetTop - currentTop;

      if (Math.abs(diff) >= 1) {
        var factor = 0.08 + easeOutCubic(progress) * 0.22;
        window.scrollTo(0, currentTop + diff * factor);
      }

      if (progress < 1 || Math.abs(diff) >= 4) {
        scrollAnimRaf = requestAnimationFrame(step);
      } else {
        scrollAnimRaf = null;
        snapSummaryBelowHeader(summary);
      }
    }

    scrollAnimRaf = requestAnimationFrame(step);
  }

  function getScrollRoot(element) {
    var node = element.parentElement;

    while (node && node !== document.body && node !== document.documentElement) {
      var style = window.getComputedStyle(node);
      var overflowY = style.overflowY;

      if (
        (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
        node.scrollHeight > node.clientHeight
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return document.documentElement;
  }

  function startAnchorLock(element) {
    stopAnchorLock();

    if (!element || isQuickViewContext(element)) return;

    anchorElement = element;
    anchorScrollRoot = getScrollRoot(element);
    anchorViewportTop = element.getBoundingClientRect().top;

    function maintain() {
      if (!isAccordionTransitioning || !anchorElement) return;

      var currentTop = anchorElement.getBoundingClientRect().top;
      var delta = currentTop - anchorViewportTop;

      if (Math.abs(delta) > 0.5) {
        if (anchorScrollRoot === document.documentElement) {
          window.scrollBy(0, delta);
        } else {
          anchorScrollRoot.scrollTop += delta;
        }
      }

      anchorLockRaf = requestAnimationFrame(maintain);
    }

    anchorLockRaf = requestAnimationFrame(maintain);
  }

  function stopAnchorLock() {
    if (anchorLockRaf) {
      cancelAnimationFrame(anchorLockRaf);
      anchorLockRaf = null;
    }

    anchorElement = null;
    anchorViewportTop = null;
    anchorScrollRoot = null;
  }

  function preparePanelTransition(panel, callback) {
    if (window.theme && window.theme.utils && typeof window.theme.utils.prepareTransition === 'function') {
      window.theme.utils.prepareTransition(panel, callback);
      return;
    }

    panel.offsetWidth;
    callback();
  }

  function ensureContentInner(panel) {
    var inner = panel.querySelector('.product-accordion__content-inner');
    if (inner) return inner;

    inner = document.createElement('div');
    inner.className = 'product-accordion__content-inner';

    if (panel.classList.contains('rte')) {
      inner.classList.add('rte');
      panel.classList.remove('rte');
    } else {
      inner.classList.add('rte');
    }

    while (panel.firstChild) {
      inner.appendChild(panel.firstChild);
    }

    panel.appendChild(inner);
    return inner;
  }

  function measurePanelHeight(panel) {
    var inner = ensureContentInner(panel);
    var height = Math.ceil(inner.scrollHeight || inner.offsetHeight);

    if (height > 0) return height;

    var probe = document.createElement('div');
    probe.className = inner.className;
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:auto;overflow:visible;width:' +
      (panel.offsetWidth || inner.offsetWidth || '100%') +
      'px';
    probe.innerHTML = inner.innerHTML;
    document.body.appendChild(probe);
    height = Math.ceil(probe.offsetHeight);
    document.body.removeChild(probe);

    return height;
  }

  function initAccordionPanelState(details) {
    var panel = details.querySelector('.product-accordion__content');
    if (!panel) return;

    ensureContentInner(panel);

    if (details.hasAttribute('open')) {
      details.classList.add('is-open');
      panel.style.height = Math.ceil(measurePanelHeight(panel)) + 'px';
    } else {
      details.classList.remove('is-open');
      panel.style.height = '0px';
    }
  }

  function pinPanelHeight(panel) {
    var height = panel.offsetHeight;
    if (!height) {
      height = measurePanelHeight(panel);
    }
    panel.style.height = height + 'px';
    return height;
  }

  function getOpenPanelHeight(details) {
    var panel = details.querySelector('.product-accordion__content');
    if (!panel) return 0;

    if (details.classList.contains('is-open') || details.open) {
      var liveHeight = panel.offsetHeight;
      if (liveHeight > 0) return liveHeight;
    }

    return measurePanelHeight(panel);
  }

  function measureOpenScrollRisk(openingDetails, root) {
    var summary = openingDetails.querySelector('.product-accordion__title');
    var openingHeight = getOpenPanelHeight(openingDetails);
    var shiftAbove = 0;
    var maxHeightDelta = 0;

    root.querySelectorAll('details.product-accordion').forEach(function (sibling) {
      if (sibling === openingDetails) return;
      if (!sibling.open && !sibling.classList.contains('is-open')) return;

      var siblingHeight = getOpenPanelHeight(sibling);
      maxHeightDelta = Math.max(maxHeightDelta, Math.abs(siblingHeight - openingHeight));

      if (summary && isAboveInDocument(sibling, summary)) {
        shiftAbove += siblingHeight;
      }
    });

    return Math.max(shiftAbove, maxHeightDelta);
  }

  function openAccordion(details, animate, onComplete, scrollMode) {
    var panel = details.querySelector('.product-accordion__content');
    var summary = details.querySelector('.product-accordion__title');
    if (!panel) {
      if (onComplete) onComplete();
      return;
    }

    ensureContentInner(panel);

    if (details.querySelector('[data-flooring-calculator]')) {
      bindFlooringCalculators(details);
    }

    var targetHeight = measurePanelHeight(panel);

    if (summary && scrollMode !== 'instant') {
      smoothScrollSummaryIntoView(summary);
    }

    function finishOpen() {
      if (summary) {
        if (scrollMode === 'instant') {
          instantScrollSummaryIntoView(summary);
        } else if (!scrollAnimRaf) {
          snapSummaryBelowHeader(summary);
        }
      }
      if (onComplete) onComplete();
    }

    if (!animate) {
      details.setAttribute('open', '');
      details.classList.add('is-open');
      panel.style.height = targetHeight + 'px';
      finishOpen();
      return;
    }

    details.setAttribute('open', '');
    panel.style.height = '0px';
    panel.offsetWidth;

    preparePanelTransition(panel, function () {
      details.classList.add('is-open');
      panel.style.height = targetHeight + 'px';
    });

    function onTransitionEnd(evt) {
      if (evt.target !== panel || evt.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onTransitionEnd);
      clearTimeout(fallbackTimer);
      if (details.classList.contains('is-open')) {
        panel.style.height = targetHeight + 'px';
      }
      finishOpen();
    }

    var fallbackTimer = setTimeout(function () {
      panel.removeEventListener('transitionend', onTransitionEnd);
      if (details.classList.contains('is-open')) {
        panel.style.height = targetHeight + 'px';
      }
      finishOpen();
    }, 600);

    panel.addEventListener('transitionend', onTransitionEnd);
  }

  function isAboveInDocument(earlier, later) {
    return Boolean(earlier.compareDocumentPosition(later) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function startCollapseScrollSync(panel, collapsedHeight) {
    var lastHeight = collapsedHeight;
    var syncRaf = null;

    function syncStep() {
      var height = panel.offsetHeight;
      var delta = lastHeight - height;

      if (delta > 0.5) {
        window.scrollBy(0, -delta);
        lastHeight = height;
      }

      if (height > 0.5) {
        syncRaf = requestAnimationFrame(syncStep);
      }
    }

    syncRaf = requestAnimationFrame(syncStep);

    return function stopCollapseScrollSync() {
      if (syncRaf) {
        cancelAnimationFrame(syncRaf);
        syncRaf = null;
      }

      var remaining = panel.offsetHeight;
      if (remaining > 0.5) {
        window.scrollBy(0, -remaining);
      }
    };
  }

  function closeAccordion(details, animate, onComplete, scrollSyncAnchor) {
    var panel = details.querySelector('.product-accordion__content');
    if (!panel) {
      if (onComplete) onComplete();
      return;
    }

    if (!details.open && !details.classList.contains('is-open')) {
      if (onComplete) onComplete();
      return;
    }

    var shouldCompensateScroll =
      scrollSyncAnchor &&
      !isQuickViewContext(scrollSyncAnchor) &&
      isAboveInDocument(details, scrollSyncAnchor);
    var stopScrollSync = null;
    var shouldSyncScroll = animate && shouldCompensateScroll;

    if (!animate) {
      details.classList.remove('is-open');
      details.removeAttribute('open');
      var instantHeight = pinPanelHeight(panel);
      if (shouldCompensateScroll) {
        window.scrollBy(0, -instantHeight);
      }
      panel.style.height = '0px';
      if (onComplete) onComplete();
      return;
    }

    var collapsedHeight = pinPanelHeight(panel);

    if (shouldSyncScroll) {
      stopScrollSync = startCollapseScrollSync(panel, collapsedHeight);
    }

    panel.offsetWidth;

    function finishClose() {
      if (stopScrollSync) {
        stopScrollSync();
        stopScrollSync = null;
      }

      details.removeAttribute('open');
      panel.style.height = '0px';
      if (onComplete) onComplete();
    }

    preparePanelTransition(panel, function () {
      details.classList.remove('is-open');
      panel.style.height = '0px';
    });

    function onTransitionEnd(evt) {
      if (evt.target !== panel || evt.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onTransitionEnd);
      clearTimeout(fallbackTimer);
      finishClose();
    }

    var fallbackTimer = setTimeout(function () {
      panel.removeEventListener('transitionend', onTransitionEnd);
      finishClose();
    }, 400);

    panel.addEventListener('transitionend', onTransitionEnd);
  }

  function markInstantAccordions(accordions) {
    accordions.forEach(function (accordion) {
      accordion.classList.add('is-instant');
    });
  }

  function clearInstantAccordions(accordions) {
    if (!accordions) return;

    accordions.forEach(function (accordion) {
      accordion.classList.remove('is-instant');
    });
  }

  function toggleAccordion(details) {
    if (isAccordionTransitioning) return;

    var root = details.closest('[data-product-accordion]');
    if (!root) return;

    var summary = details.querySelector('.product-accordion__title');
    if (!summary) return;

    isAccordionTransitioning = true;
    var willOpen = !details.classList.contains('is-open');
    var pendingAnimations = 0;
    var instantAccordions = null;

    if (!willOpen) {
      var closingHeightForLock = getOpenPanelHeight(details);
      if (closingHeightForLock < SCROLL_INSTANT_LAYOUT_SHIFT_THRESHOLD && !isQuickViewContext(summary)) {
        startAnchorLock(summary);
      }
    }

    function trackAnimation(done) {
      pendingAnimations += 1;

      return function () {
        if (done) done();
        pendingAnimations -= 1;
        if (pendingAnimations <= 0) {
          clearInstantAccordions(instantAccordions);
          instantAccordions = null;
          stopAnchorLock();
          isAccordionTransitioning = false;
        }
      };
    }

    if (willOpen) {
      var scrollRisk = measureOpenScrollRisk(details, root);
      var useInstant = scrollRisk >= SCROLL_INSTANT_LAYOUT_SHIFT_THRESHOLD;

      if (useInstant) {
        instantAccordions = [details];

        root.querySelectorAll('details.product-accordion').forEach(function (sibling) {
          if (sibling !== details && (sibling.open || sibling.classList.contains('is-open'))) {
            instantAccordions.push(sibling);
          }
        });

        markInstantAccordions(instantAccordions);

        root.querySelectorAll('details.product-accordion').forEach(function (sibling) {
          if (sibling !== details && (sibling.open || sibling.classList.contains('is-open'))) {
            closeAccordion(sibling, false, trackAnimation(), summary);
          }
        });

        openAccordion(
          details,
          false,
          trackAnimation(),
          'instant'
        );
        return;
      }

      root.querySelectorAll('details.product-accordion').forEach(function (sibling) {
        if (sibling !== details && (sibling.open || sibling.classList.contains('is-open'))) {
          closeAccordion(sibling, true, trackAnimation(), summary);
        }
      });

      openAccordion(
        details,
        true,
        trackAnimation(),
        'smooth'
      );
      return;
    }

    var closingHeight = getOpenPanelHeight(details);
    var useInstantClose = closingHeight >= SCROLL_INSTANT_LAYOUT_SHIFT_THRESHOLD;

    if (useInstantClose) {
      instantAccordions = [details];
      markInstantAccordions(instantAccordions);
    }

    closeAccordion(details, !useInstantClose, trackAnimation());
  }

  function bindAccordionInteractions(root) {
    root.querySelectorAll('details.product-accordion').forEach(function (details) {
      initAccordionPanelState(details);

      if (details.dataset.interactionBound === 'true') return;
      details.dataset.interactionBound = 'true';

      var summary = details.querySelector('.product-accordion__title');
      if (!summary) return;

      summary.addEventListener('click', function (evt) {
        evt.preventDefault();
        summary.blur();
        toggleAccordion(details);
      });
    });
  }

  function createAccordionElement(section, accordionName, isOpen) {
    var details = document.createElement('details');
    details.className = 'product-accordion';
    details.setAttribute('data-accordion-block', '');
    details.setAttribute('data-accordion-block-type', 'description');

    if (isOpen) {
      details.setAttribute('open', '');
    }

    var summary = document.createElement('summary');
    summary.className = 'product-accordion__title';

    var titleText = document.createElement('span');
    titleText.className = 'product-accordion__title-text';
    titleText.textContent = section.title;

    var icon = document.createElement('span');
    icon.className = 'product-accordion__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg class="icon icon-chevron-down" viewBox="0 0 28 16" focusable="false" role="presentation">' +
      '<path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="currentColor" fill="none"/>' +
      '</svg>';

    summary.appendChild(titleText);
    summary.appendChild(icon);

    var content = document.createElement('div');
    content.className = 'product-accordion__content';

    var contentInner = document.createElement('div');
    contentInner.className = 'product-accordion__content-inner rte';
    contentInner.innerHTML = section.content;

    content.appendChild(contentInner);

    details.appendChild(summary);
    details.appendChild(content);

    return details;
  }

  function bindExclusiveOpen(root) {
    bindAccordionInteractions(root);
  }

  function resetFlooringCalculatorState(root) {
    if (!root) return;

    root.removeAttribute('data-flooring-bound');
    delete root.dataset.fcBound;
  }

  function bindFlooringCalculators(scope) {
    var bindFn =
      typeof window.bindFlooringCalculator === 'function'
        ? window.bindFlooringCalculator
        : window.FlooringCalculator && typeof window.FlooringCalculator.bind === 'function'
          ? window.FlooringCalculator.bind
          : null;

    if (!bindFn) return;

    scope.querySelectorAll('[data-flooring-calculator]').forEach(function (el) {
      if (el.closest('[data-accordion-blocks][hidden]')) return;
      if (el.getAttribute('data-flooring-bound') === 'true') return;

      bindFn(el);
    });
  }

  function buildGroup(root) {
    if (root.dataset.accordionInitialized === 'true') return;

    var source = root.querySelector('[data-accordion-source]');
    var mount = root.querySelector('[data-accordion-mount]');
    var blocksContainer = root.querySelector('[data-accordion-blocks]');

    if (!source || !mount) return;

    var accordionName =
      root.dataset.accordionName ||
      'nf-accordion-' + root.dataset.sectionId + '-' + root.dataset.productId;
    var descriptionLabel = root.dataset.descriptionLabel || 'Description';

    mount.innerHTML = '';

    var sections = buildDescriptionSections(source.innerHTML, descriptionLabel);
    var hasOpen = false;

    sections.forEach(function (section) {
      var openFirst = !hasOpen;
      if (openFirst) hasOpen = true;
      mount.appendChild(createAccordionElement(section, accordionName, openFirst));
    });

    if (blocksContainer) {
      var blockNodes = blocksContainer.querySelectorAll('[data-accordion-block]');
      blockNodes.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.removeAttribute('open');
        clone.querySelectorAll('[data-flooring-calculator]').forEach(resetFlooringCalculatorState);
        if (!hasOpen) {
          clone.setAttribute('open', '');
          hasOpen = true;
        }
        mount.appendChild(clone);
      });
    }

    if (!mount.children.length) {
      root.hidden = true;
    } else {
      root.hidden = false;
    }

    bindExclusiveOpen(root);
    bindFlooringCalculators(root);

    root.dataset.accordionInitialized = 'true';
  }

  function init(scope) {
    var el = scope || document;
    el.querySelectorAll('[data-product-accordion]:not([data-accordion-initialized])').forEach(
      buildGroup
    );
  }

  function reset(scope) {
    var el = scope || document;
    el.querySelectorAll('[data-product-accordion]').forEach(function (root) {
      root.removeAttribute('data-accordion-initialized');
      root.hidden = false;
      var mount = root.querySelector('[data-accordion-mount]');
      if (mount) mount.innerHTML = '';
      root.querySelectorAll('[data-accordion-block][data-exclusive-bound]').forEach(function (d) {
        d.removeAttribute('data-exclusive-bound');
      });
    });
    init(el);
  }

  window.theme = window.theme || {};
  window.theme.productAccordion = {
    init: init,
    reset: reset,
    buildGroup: buildGroup
  };

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('quickview:loaded', function (evt) {
    var productId = evt.detail && evt.detail.productId;
    if (!productId) {
      init(document);
      return;
    }

    var modal = document.getElementById('QuickShopModal-' + productId);
    if (modal) {
      init(modal);
    } else {
      init(document);
    }
  });
})();
